export default __webpack_public_path__ + "static/media/flag.f5d8ab3c.svg";